import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// options: [{ value, label, sub }]
export function SearchSelect({ value, options, onChange, placeholder = "Select…", disabled, testid, searchPlaceholder = "Search…" }) {
  const [open, setOpen] = useState(false);
  const selected = options.find((o) => o.value === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          disabled={disabled}
          data-testid={testid}
          className={cn(
            "w-full justify-between h-12 rounded-xl border-slate-700 bg-slate-900/60 px-4 text-left font-medium text-slate-100 hover:bg-slate-800/70 hover:text-white",
            !selected && "text-slate-500"
          )}
        >
          <span className="truncate">{selected ? selected.label : placeholder}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 text-slate-500" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0 border-slate-700 bg-slate-900" align="start">
        <Command className="bg-slate-900">
          <CommandInput placeholder={searchPlaceholder} className="text-slate-100" />
          <CommandList className="max-h-64">
            <CommandEmpty className="py-6 text-center text-sm text-slate-500">No match found.</CommandEmpty>
            <CommandGroup>
              {options.map((o) => (
                <CommandItem
                  key={o.value}
                  value={`${o.label} ${o.sub || ""}`}
                  data-testid={testid ? `${testid}-option-${o.value}` : undefined}
                  onSelect={() => {
                    onChange(o.value);
                    setOpen(false);
                  }}
                  className="flex items-center justify-between gap-2 rounded-lg text-slate-200 aria-selected:bg-orange-500/15 aria-selected:text-orange-200"
                >
                  <span className="font-mono font-semibold">{o.label}</span>
                  <span className="flex items-center gap-2">
                    {o.sub && <span className="text-xs text-slate-500">{o.sub}</span>}
                    {value === o.value && <Check className="h-4 w-4 text-orange-400" />}
                  </span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
